import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { placeholderProfilePicture } from 'common/apartmentLocatorHelpers';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import {
  USER_ROLE_AGENT,
  USER_ROLE_ADMIN,
} from 'common/userRoles';

import {
  SCREEN_ID_AGENT_PROFILE,
} from 'client/constants/screenIds';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles, { getUserLandingPage } from 'client/helpers/allowedRoles';

import Navbar from 'client/components/Navbar';
import SrAgentDashboardTabBar from 'client/components/SrAgentDashboardTabBar';
import SrAgentLeaderboardCard from 'client/components/SrAgentLeaderboardCard';
import AgentActions from 'client/actions/Agent';

@withTransitionHook
@withScrollToTop
@allowedRoles({
  roles: [USER_ROLE_AGENT, USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_AGENT_PROFILE)
@branch({
  currentUser: ['currentUser'],
})
class TourGuideProfilePage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Profile | Sunroom Rentals',
  });

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
  }

  static fetchData(match, inject) {
    const startDate = momentWithAustinTimezone().startOf('month').toISOString();
    const endDate = momentWithAustinTimezone().endOf('month').toISOString();
    return AgentActions.getLeaderboard(inject, { startDate, endDate });
  }

  render() {
    const {
      currentUser,
    } = this.props;

    return (
      <div className='page-agentDashboard profile'>
        <Navbar
          redirectLogoTo={getUserLandingPage({ userRoles: currentUser.roles })}
        />
        <SrAgentDashboardTabBar />
        <div className='contentContainer'>
          <div className='bioContainer'>
            <div className='avatarContainer'>
              <img
                className='apartmentLocatorProfilePicture'
                src={currentUser.profilePicture || placeholderProfilePicture}
                alt={currentUser.name}
              />
            </div>
            <div className='textContainer'>
              <span className='welcome'>{currentUser.name}</span>
            </div>
          </div>
          <div className='cardsContainer'>
            <SrAgentLeaderboardCard
              userRole={USER_ROLE_AGENT}
            />
          </div>
        </div>
      </div>
    );
  }
}

TourGuideProfilePage.displayName = 'TourGuideProfilePage';

export default TourGuideProfilePage;
